export enum CompanyType {
  CLIENT = 10,
  SUPPLIER = 20,
}

export type Company = {
  id: string;
  name: string;
  type: CompanyType;
};
